import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { getData, getInputParams, currencyFormatter, csvUrl } from '../CustomUtils.js'
import { AIG_REPORT_QUERY, AIG_UPDATED_PARAMETERS_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ReportHeading from '../ReportHeading.js'
import ParameterValues from '../ParameterValues.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportFooter from '../ReportFooter.js'
import '../Custom.css'
import ReportGrid from '../ReportGrid.js'
import ReportTotalsRow from '../ReportTotalsRow.js'

const AIG_REPORT = gql(AIG_REPORT_QUERY)
const AIG2_REPORT = gql(AIG_UPDATED_PARAMETERS_REPORT_QUERY)

export default function AIGReport() {
  const location = useLocation()
  console.log('AIGReport rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    const REPORT = location.pathname.split('/')[2] === 'aig.aig_report' ? AIG_REPORT : AIG2_REPORT
    const gqlDataName = location.pathname.split('/')[2] === 'aig.aig_report' ? 'aigReport' : 'aigUpdatedParametersReport'
    getData(location, REPORT, gqlDataName, setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const inputs = getInputParams(location)
    inputs.reportType = !inputs.reportType ? 'I' : inputs.reportType
    let title = ''
    let totalColumn = [{ columnNumber: 2 }]
    let columnFormatter = [{ columnNumber: 2, formatter: currencyFormatter().format, align: 'right' }]
    switch (inputs.reportType) {
      case 'I':
        title = 'Indemnity Payments'
        totalColumn = inputs.showPlaintiffCounsel ? [{ columnNumber: 6 }] : [{ columnNumber: 5 }]
        columnFormatter = inputs.showPlaintiffCounsel ? [{ columnNumber: 6, formatter: currencyFormatter().format, align: 'right' }] : [{ columnNumber: 5, formatter: currencyFormatter().format, align: 'right' }]
        break
      case 'D':
        title = 'Defense Costs'
        break
      case 'IP':
        title = 'Indemnity Payments (by Claimant\'s Counsel)'
        break
      default:
    }
    const url = location.pathname.split('/')[2] === 'aig.aig_report' ? 'Asbestos/aigReport/aig_report' : 'Asbestos/aigUpdatedParametersReport/aig_report'
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <b>EXHIBIT {inputs.reportType === 'I' ? 'A' : 'B'} to the Periodic Billing Report</b> &emsp;
          <LargeRowHandler csvUrl={csvUrl(url, location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{ backgroundColor: 'white', width: 'auto', margin: 'auto' }} >
          <ReportHeading title={title} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} columnFormatters={columnFormatter} />
            <ReportTotalsRow reportData={results.reportData} totalColumns={totalColumn} />
          </tbody>
        </Table>
        <ReportFooter>Contains Confidential Information <br /> Subject to Paragraph 15.1 of Settlement Agreement</ReportFooter>
      </div>
    )
  }
}